<div class="isg-full-page-header">

  <div class="isg-page-header">
    <span>System Logs</span>
  </div>
  <div class="isg-page-body">

    
    <div class="isg-log-grid-wrapper">

      <kendo-grid [data]="view | async"
                  [pageSize]="state.take"
                  [skip]="state.skip"
                  [sort]="state.sort"
                  [resizable]="true"
                  [pageable]="{
                      buttonCount:5,
                      pageSizes:[5, 10, 15, 20, 50]
                    }"
                  (dataStateChange)="onStateChange($event)"
                  [height]="heightGrid">

        <ng-template kendoGridToolbarTemplate>
          <div class="isg-log-toolbar-top">
            <div>
              <kendo-label [for]="tstampSelect" text="Duration"></kendo-label>
              <kendo-combobox #tstampSelect
                              class="isg-log-period-filter"
                              [(ngModel)]="selectedTimePeriod"
                              [data]="timePeriods"
                              [suggest]="true">
              </kendo-combobox>
            </div>
            <div>
              <kendo-label [for]="loggedBy" text="Logged By"></kendo-label>
              <kendo-textbox #loggedBy
                             class="isg-log-loggedby-filter"
                             [(ngModel)]="filterLoggedBy"></kendo-textbox>
            </div>
            <div>
              <kendo-label [for]="source" text="Source"></kendo-label>
              <kendo-textbox #source
                             class="isg-log-source-filter"
                             [(ngModel)]="filterSource"></kendo-textbox>
            </div>
          </div>
          <div class="isg-log-toolbar-bottom">
            <div>
              <kendo-label [for]="severitySelect" text="Severity"></kendo-label>
              <kendo-multiselect #severitySelect
                                 class="isg-log-severity-filter"
                                 [(ngModel)]="filterSeverities"
                                 [data]="severityLevels">
              </kendo-multiselect>
            </div>
            <div>
              <kendo-label [for]="categorySelect" text="Category"></kendo-label>
              <kendo-multiselect #categorySelect
                                 class="isg-log-category-filter"
                                 [(ngModel)]="filterCategoryIds"
                                 [data]="logCategories"
                                 textField="name"
                                 valueField="id"
                                 [valuePrimitive]="true">
              </kendo-multiselect>
            </div>
            <div>
              <button kendoButton type="button" (click)="onSearchClick()">
                <span class="fas fa-magnifying-glass" title="Search"></span>
              </button>
              <button kendoButton type="button" (click)="onResetClick()">
                <span class="fas fa-solid fa-rotate" title="Refresh"></span>
              </button>
            </div>
          </div>

        </ng-template>

        <kendo-grid-column field="loggedOn" title="Created On" [width]="200">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.loggedOn | utcToLocal }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="severity" title="Severity" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span [ngClass]="getSeverityClass(dataItem.severity)">{{dataItem.severity}}</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="categoryName" title="Category" [width]="100">
        </kendo-grid-column>

        <kendo-grid-column field="message" title="Message">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="isg-kgrid-cell-vertscroll-m">
              {{ dataItem.message }}
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="loggedBy" title="Logged By" [width]="300">
        </kendo-grid-column>

        <kendo-grid-command-column [width]="60">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <button kendoButton type="button" title="Details" (click)="onDetailClick(dataItem)">
              <span class="fa-solid fa-magnifying-glass"></span>
            </button>
          </ng-template>
        </kendo-grid-command-column>

        <kendo-grid-messages [pagerItemsPerPage]="'Logs per request'" [pagerItems]="'Logs'"
                             [pagerOf]="'of'" [pagerPage]="'Page'">
        </kendo-grid-messages>

      </kendo-grid>

      <app-log-system-detail *ngIf="selectedRow"
                             [data]="selectedRow"
                             (cancel)="onCancel()">
      </app-log-system-detail>

    </div>


  </div>

</div>
